/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteChatSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteChatRequest = {
  /**
   * The ID of the chat to delete
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteChatSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteChatSecurity$outboundSchema: z.ZodMiniType<
  DeleteChatSecurity$Outbound,
  DeleteChatSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteChatSecurityToJSON(
  deleteChatSecurity: DeleteChatSecurity,
): string {
  return JSON.stringify(
    DeleteChatSecurity$outboundSchema.parse(deleteChatSecurity),
  );
}

/** @internal */
export type DeleteChatRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteChatRequest$outboundSchema: z.ZodMiniType<
  DeleteChatRequest$Outbound,
  DeleteChatRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteChatRequestToJSON(
  deleteChatRequest: DeleteChatRequest,
): string {
  return JSON.stringify(
    DeleteChatRequest$outboundSchema.parse(deleteChatRequest),
  );
}
